import { Enum } from "./Enum";

export const E_PROMOTION = Object.freeze({
  MAIN: (id = ":id") => `/promotion/${id}`,
  LISTING: () => `/promotion`,
  CREATE: () => `/promotion`,
  UPDATE: (id = ":id") => `/promotion/${id}`,
  DELETE: (id = ":id") => `/promotion/${id}`,
  GET_BY_CODE: (code: string) => `/promotion/apply/${code}`,
});

export type PROMOTION = Enum<typeof E_PROMOTION>;
